/* The feature of a care task. */
export enum CareTaskFeature {
  /* Health measurement of body temperature. */
  BodyTemperatureHealthMeasurement = 'body-temperature-health-measurement',

  /* Health measurement of body weight. */
  BodyWeightHealthMeasurement = 'body-weight-health-measurement',

  /* Health measurement of body height. */
  BodyHeightHealthMeasurement = 'body-height-health-measurement',

  /* Health measurement of heart rate. */
  HeartRateHealthMeasurement = 'heart-rate-health-measurement',

  /* Health measurement of blood oxygen. */
  BloodOxygenHealthMeasurement = 'blood-oxygen-health-measurement',

  /* Health measurement of blood pressure. */
  BloodPressureHealthMeasurement = 'blood-pressure-health-measurement',

  /* Health measurement of respiratory rate. */
  RespiratoryRateHealthMeasurement = 'respiratory-rate-health-measurement',

  /* Health measurement of blood glucose. */
  BloodGlucoseHealthMeasurement = 'blood-glucose-health-measurement',

  /* Health measurement of body fat percentage. */
  BodyFatPercentageHealthMeasurement = 'body-fat-percentage-health-measurement',

  /* Health measurement of body muscle percentage. */
  BodyMusclePercentageHealthMeasurement = 'body-muscle-percentage-health-measurement',

  /* Health measurement of body water percentage. */
  BodyWaterPercentageHealthMeasurement = 'body-water-percentage-health-measurement',

  /* Health measurement of natriuretic peptide test. */
  NatriureticPeptideTestHealthMeasurement = 'natriuretic-peptide-test-health-measurement',

  /* Health measurement of steps. */
  StepsHealthMeasurement = 'steps-health-measurement',

  /* Health measurement of steps. */
  SleepHealthMeasurement = 'sleep-health-measurement',
}
